import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';

@Component({
  selector: 'app-payment-methods',
  standalone: true,
  imports: [RouterLink, DecimalPipe, FuseCardComponent, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './payment-methods.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodsComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);

  dataLoader = false;
  error: string | null = null;
  methods: { label: string; amount: number; percentage: number; color: string }[] = [];
  totalPayments = 0;

  readonly methodColors = ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6'];

  @Input() collectionRecord: any = null;

  ngOnChanges(_changes: SimpleChanges) {
    this.methods = [];
    this.totalPayments = 0;

    if (!this.collectionRecord) {
      this.dataLoader = true;
      this.cdr.markForCheck();
      return;
    }

    const byMethod: any[] = this.collectionRecord.by_method || [];
    this.totalPayments = byMethod.reduce((sum: number, m: any) => sum + (m.amount || 0), 0);
    this.methods = byMethod
      .filter((m: any) => m.amount > 0)
      .map((m: any, i: number) => ({
        label: m.payment_method,
        amount: m.amount || 0,
        percentage: this.totalPayments > 0 ? Math.round((m.amount / this.totalPayments) * 100) : 0,
        color: this.methodColors[i % this.methodColors.length],
      }))
      .sort((a, b) => b.percentage - a.percentage);

    this.dataLoader = false;
    this.cdr.markForCheck();
  }
}
